<div class="app-container" [class.show-side-menu]="sideMenuState">
    @if(isCustomerChecked) {
    <avenir-header (sideMenuState)="sideMenuStateFnc($event)" [customerId]="customerId" [isLoggedIn]="isLoggedIn"></avenir-header>
    }
    <div class="content">
        <router-outlet />
    </div>
    <avenir-footer></avenir-footer>
</div>

<avenir-loader></avenir-loader>
<avenir-toast></avenir-toast>
